import { type AuthClient, createClient } from './client-core';
import { activateFirstOrganization } from './organization-client';

export interface AppAuthClientOptions {
  includeSignUp?: boolean;
}

export type BaseAppAuthClient = {
  activateFirstOrganization: typeof activateFirstOrganization;
  authClient: AuthClient;
  signIn: AuthClient['signIn'];
  signOut: AuthClient['signOut'];
  useSession: AuthClient['useSession'];
};

export type AppAuthClient = BaseAppAuthClient & {
  signUp?: AuthClient['signUp'];
};

export type AppAuthClientWithSignUp = BaseAppAuthClient & {
  signUp: AuthClient['signUp'];
};

export function createAppAuthClient(baseURL?: string): BaseAppAuthClient;
export function createAppAuthClient(
  baseURL: string | undefined,
  options: { includeSignUp: true },
): AppAuthClientWithSignUp;
export function createAppAuthClient(
  baseURL?: string,
  options: AppAuthClientOptions = {},
): AppAuthClient {
  const authClient = createClient(baseURL);

  const client: BaseAppAuthClient = {
    activateFirstOrganization,
    authClient,
    signIn: authClient.signIn,
    signOut: authClient.signOut,
    useSession: authClient.useSession,
  };

  if (options.includeSignUp) {
    return {
      ...client,
      signUp: authClient.signUp,
    };
  }

  return client;
}
